import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import enHome from "./locales/en/home.json";
import roHome from "./locales/ro/home.json";
import enService from "./locales/en/services.json";
import roService from "./locales/ro/services.json";
import enPortfolio from "./locales/en/portfolio.json";
import roPortfolio from "./locales/ro/portfolio.json";
import enContact from "./locales/en/contact.json";
import roContact from "./locales/ro/contact.json";
import enPrivacyPolicy from "./locales/en/privacy-policy.json";
import roPrivacyPolicy from "./locales/ro/privacy-policy.json";
import enNotFound from "./locales/en/not-found.json";
import roNotFound from "./locales/ro/not-found.json";

const resources = {
  en: {
    translation: enHome,
    service: enService,
    portfolio: enPortfolio,
    contact: enContact,
    "privacy-policy": enPrivacyPolicy,
    notFound: enNotFound,
  },
  ro: {
    translation: roHome,
    service: roService,
    portfolio: roPortfolio,
    contact: roContact,
    "privacy-policy": roPrivacyPolicy,
    notFound: roNotFound,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    debug: false,

    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },

    interpolation: {
      escapeValue: false,
    },

    returnObjects: true,
  });

export default i18n;
